import {
  faFileInvoiceDollar,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import sourcingDashboardDetails from './sourcingDashboardDetails';
export default {
  name: 'sourcingApproval',
  components: {
    faFileInvoiceDollar,
    faArrowRight,
    sourcingDashboardDetails
  },
  data() {
    return {
      count1: 0,
      showCard: false,
      cardName: null,
      loader: false,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: true,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false
      }
    };
  },
  mounted() {
    this.getPendingPOSyncCount();
  },
  methods: {
    showHideCard(flag, type) {
      this.cardName = null;
      const typeCountMap = {
        pendingPOSync: this.count1
      };

      if (type && typeCountMap[type] === 0) {
        this.$bvToast.toast('No records found.', {
          title: 'Alert',
          variant: 'danger',
          solid: true,
          autoHideDelay: 7000
        });
        return;
      }
      this.showCard = flag;
      this.cardName = type;
    },
    getPendingPOSyncCount() {
      // 1.1 (Akhil) Function to get the count of Pending PO
      this.loader = true;
      this.$store
        .dispatch('vendorDashboard/getPendingPoSyncCount')
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.count1 = resp.data.data.count;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
  }
};
